<template>
  <div class="v-box" style="display: inline-block ">
    <slot></slot>
    <transition name="fade">
      <div class="v-box_box" v-show="visible">
        <!--      <div class="v-box_box">-->
        <i class="v-box_close" @click="close"></i>
        <p class="v-box_title">安全验证</p>
        <p class="v-box_sub">拖动下方滑块完成拼图</p>
        <div class="v-box_img" ref="imgWrap">
          <img class="v-box_img_bg" ref="imgBg" src="" alt="">
          <img class="v-box_img_icon" ref="imgIcon" src="" alt="">
        </div>
        <div class="v-box_range" ref="range">
          <div class="v-box_range_track"></div>
          <button class="v-box_range_btn" ref="rangeBtn"></button>
          <div class="v-box_range_mask" ref="rangeMask"></div>
        </div>
        <div class="v-box_foot">
          <div>
          <span style="color:#FF0000" v-if="error">
            {{ options.errorText }}
          </span>
            <span style="color:#00ff5d" v-if="success">
            {{ options.successText }}
          </span>
          </div>
          <img @click="refresh" class="v-box_foot_refresh" src="./static/refresh.png" alt="">
        </div>
      </div>
    </transition>
  </div>
</template>
<script>

export default {
  name: 'XrkSlideVerify',
  props: {
    options: {
      type: [Object],
      default: () => ({
        remoteTimerInterval: 800,
        errorText: '请控制拼图块对齐缺口',
        successText: '验证成功',
        remoteApi: {
          // 获取图片，拼图Y轴
          initImages: '',
          // 验证接口
          checkVerification: ''
        },
        errorAnimationDuration: 0
      })
    },
  },
  data() {
    return {
      visible: false,
      error: false,
      success: false,
      startBtnX: 0,
      requestLock: false,
      remoteTimerId: '',
      remoteTimerInterval: 600,
      animationDuration: 300,
      y: '',
      x: ''
    };
  },
  watch: {
    'visible': {
      handler: function(v, oldv) {
        if (v) {
          this.initImg();
        }
      },
      immediate: true
    }
  },
  methods: {
    refresh() {
      this.error = false;
      this.initImg();
    },
    close() {
      this.$refs['imgBg'].src = '';
      this.$refs['imgIcon'].src = '';
      Object.assign(this.$data, this.$options.data());
    },
    // 初始化图片
    initImg() {
      this.startBtnX = 0;
      let rangeBtn = this.$refs['rangeBtn'];
      let imgBg = this.$refs['imgBg'];
      let imgIcon = this.$refs['imgIcon'];
      return new Promise((resolve, reject) => {
        this.options['remoteApi'].getVerification()
          .then(res => {
            const { data: { data: { shadeImage, cutoutImage, y } } } = res;
            console.log();
            let rangeBtn = this.$refs['rangeBtn'];
            rangeBtn.style.left = '0px';
            imgIcon.style.left = '0px';
            imgBg.src = 'data:image/jpg;base64,' + shadeImage;
            imgIcon.src = 'data:image/png;base64,' + cutoutImage;
            imgIcon.style.top = y + 'px';
            // FIXME
            this.y = y;
            resolve();
          })
          .catch(reject);
      });
    }
  },
  mounted() {
    let rangeBtn = this.$refs['rangeBtn'];
    let rangeMask = this.$refs['rangeMask'];
    let imgBg = this.$refs['imgBg'];
    let imgIcon = this.$refs['imgIcon'];

    // 移动滑块
    let moveRangeBtn = e => {
      e.preventDefault();
      if (e.type === 'mousemove') {
        rangeBtn.style.left = `${Math.max(0, e.offsetX - this.startBtnX)}px`;
        imgIcon.style.left = `${Math.max(0, e.offsetX - this.startBtnX)}px`;
      }
      if (e.type === 'touchmove') {
        console.log(e.touches[0]);
      }
    };

    // 按下鼠标 监听 move 和 leave
    rangeMask.addEventListener('mousedown', e => {

      if (e.offsetX > rangeBtn.offsetWidth || e.offsetX < 0) return;

      // 点击区域 是按钮的位置
      this.startBtnX = e.offsetX;
      rangeMask.addEventListener('mousemove', moveRangeBtn);
      // 抬起或者离开，监听一种即可
      rangeMask.addEventListener('mouseup', remoteVerification);
      rangeMask.addEventListener('mouseup', () => rangeMask.removeEventListener('mouseleave', remoteVerification));
      rangeMask.addEventListener('mouseup', () => rangeMask.removeEventListener('mousemove', moveRangeBtn));

      rangeMask.addEventListener('mouseleave', remoteVerification);
      rangeMask.addEventListener('mouseleave', () => rangeMask.removeEventListener('mouseup', remoteVerification));
      rangeMask.addEventListener('mouseleave', () => rangeMask.removeEventListener('mousemove', moveRangeBtn));
    }, false);

    // 服务器验证
    const remoteVerification = (e) => {
      if (this.requestLock) return;
      this.requestLock = true;

      let x = e.offsetX - this.startBtnX;
      this.options['remoteApi'].checkVerification({ x, y: this.y })
        .then(res => {
          // const { status } = res;
          this.remoteTimerId = setTimeout(() => {
            this.requestLock = false;
            clearTimeout(this.remoteTimerId);
          }, this.remoteTimerInterval);

          // 验证通过
          // if (+status === 1) {
          console.log('验证通过。。。');
          this.error = false;
          this.success = true;
          this.animationTimer = setTimeout(() => {
            this.success = false;
            // 初始化样式
            imgBg.src = '';
            imgIcon.src = '';
            imgIcon.style.top = '0px';
            rangeBtn.style.left = '0px';
            imgIcon.style.left = '0px';

            this.error = false;
            this.visible = false;
            this.requestLock = false;
            this.$emit('success');
          }, 1000);
        })
        .catch(() => {
          console.log('err');
          console.log('验证失败。。。');
          imgIcon.style.animation = `jitter ${this.animationDuration}ms`;
          rangeBtn.style.animation = `jitter ${this.animationDuration}ms`;

          this.error = true;
          this.animationTimer = setTimeout(() => {
            //初始化图片信息
            this.initImg()
              .then(() => {
                clearTimeout(this.animationTimer);
                imgIcon.style.animation = '';
                rangeBtn.style.animation = '';
              });
            this.requestLock = false;
          }, this.animationDuration);
        });
    };
  },
  destroyed() {
    clearTimeout(this.remoteTimerId);
  }
};
</script>
<style lang="scss">
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */
{
  opacity: 0;
}

@keyframes jitter {
  0% {
    transform: translateX(0px);
  }
  25% {
    transform: translateX(-5px);
  }
  50% {
    transform: translateX(5px);
  }
  75% {
    transform: translateX(-5px);
  }
  100% {
    transform: translateX(0px);
  }
}
.v-box {
  position: relative;
  user-select: none;

  &_box {
    position: absolute;
    right: 10px;
    bottom: 0px;
    width: 310px;
    height: 348px;
    background-color: #ffffff;
    border-radius: 8px;
    z-index: 9999;
    box-shadow: 2px 4px 20px #2e2f2f;
    padding: 16px 12px;
  }

  &_title {
    font-size: 20px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 20px;
    letter-spacing: 0;
    color: #141413;
    margin-bottom: 16px;
    text-align: center;
  }

  &_sub {
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 14px;
    letter-spacing: 0;
    color: #141413;
    padding-bottom: 12px;
  }

  &_close {
    position: absolute;
    right: 8px;
    top: 8px;
    width: 24px;
    height: 24px;
    border-radius: 14px;
    background: url("./static/close.png");
    cursor: pointer;
  }

  &_img {
    width: 280px;
    height: 171px;
    //background-color: #ffffff;
    border-radius: 6px;
    position: relative;
    overflow: hidden;

    &_bg {
      width: 280px;
      height: 171px;
    }

    &_icon {
      position: absolute;
      top: 0;
      left: 0;
      width: 55px;
      height: 55px;
      //background-color: rgba(0, 0, 0, 0.2);
      //box-shadow: inset 0px 0px 6px 0px #ffffff,
      //0px 1px 4px 0px rgba(0, 0, 0, 0.56);
      //border-radius: 2px;
    }
  }

  &_range {
    margin-top: 20px;
    height: 40px;
    position: relative;
    box-sizing: border-box;
    display: flex;
    align-items: center;

    &_track {
      width: 286px;
      height: 12px;
      background-color: #f0f0ef;
      border-radius: 6px;
      position: relative;
    }

    &_btn {
      width: 36px;
      height: 28px;
      //width: 54px;
      //height: 42px;
      box-shadow: 0 0 4px 0 #f7e00b;
      border-radius: 14px;
      border: none;
      box-sizing: border-box;
      outline: none;
      position: absolute;
      background: url("./static/range_btn.png");
      background-size: 100% 100%;
      left: 0;
      //border: 1px solid #000;
    }

    &_mask {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 40px;
      z-index: 9999;
      cursor: pointer;
    }
  }

  &_foot {
    display: flex;
    justify-content: space-between;
    align-items: center;

    &_refresh {
      width: 28px;
      height: 28px;
      cursor: pointer;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/packages/slide-verify/src/main.vue